import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params } from '@angular/router';
import { AuthService } from '../../auth.service';
import { QuibblService } from '../../quibbl.service';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { AngularFireDatabase } from 'angularfire2/database';

const BANNER_FADE_START = 10.0;
const BANNER_FADE_DISTANCE = 100.0;

@Component({
  selector: 'quibbl-inspector',
  templateUrl: './quibbl-inspector.component.html',
  styleUrls: ['./quibbl-inspector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuibblInspectorComponent implements OnInit {
  public quibblIdentifier: string;
  public identifierSubscription;
  public embedCodeStr;
  public currentQuibbl;
  public currentQuibblSubscription;

  public nextQuibbl;

  public maxOdds = 0;
  public minOdds = 1.0;
  public crowdFavorite = '';
  public longShot = '';

  public optionPayouts;

  public myCurrentVote: number = -1;
  public currentVoteSubscription;

  public category;

  public bannerAlpha: number = 1.0;
  public bannerYOffset: number = 0;

  public now = Date.now();

  public links;

  public commentSubscription;
  public commentCount;

  @ViewChild('quibblInspector') private scrollContainer: ElementRef;
  @ViewChild('embedCode') private embedCode: ElementRef;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private auth: AuthService,
              private _qb: QuibblService) { }

  ngOnInit() {
    // Grab the quibbl
    this.identifierSubscription = this.route.params.subscribe(params => {
      // Reset current vote and quibbl ID
      this.myCurrentVote = -1;
      this.quibblIdentifier = params['quibblId'];
      this._qb.currentQuibblIdentifier = this.quibblIdentifier;

      // Generate embed code
      this.embedCodeStr = "<iframe src=\"https://d2e22ex66ymul9.cloudfront.net/" + this.quibblIdentifier + "\" id=\"qb-" + this.quibblIdentifier + "\" frameborder=\"0\" allowtransparency=\"true\" width=\"100%\" onload=\"window.addEventListener('message',function resizeIframe(e){var a=document.getElementById('qb-" + this.quibblIdentifier + "'),t=e.data[0],i=e.data[1];switch(t){case'setHeight':a.style.height=i+'px';break;case'setWidth':a.style.width=i+'px'}},false);\"></iframe>";

      this.currentQuibbl = this._qb.getQuibbl(this.quibblIdentifier);
      if(this.currentQuibblSubscription) this.currentQuibblSubscription.unsubscribe();
      this.currentQuibblSubscription = this.currentQuibbl.subscribe(currQuibbl => {
        this.category = currQuibbl.category;
        this.maxOdds = 0;
        this.minOdds = 1.0;
        this.optionPayouts = [];
        let i = 0;
        for(let option of currQuibbl.options) {
          this.optionPayouts[i] = {
            right: (1 / option.odds) * currQuibbl.points,
            wrong: (1 / (1 - option.odds)) * currQuibbl.points
          }

          if(option.odds > this.maxOdds) {
            this.maxOdds = option.odds;
            this.crowdFavorite = option.name;
          }

          if(option.odds < this.minOdds) {
            this.minOdds = option.odds;
            this.longShot = option.name;
          }
          i++;
        }

        this.links = [];
        if(currQuibbl.links) {
          let i = 0;
          for(let link of currQuibbl.links) {
            if(link) {
              let identifiers = link.split('.');
              let identifier = (identifiers.length == 2) ? identifiers[0] : identifiers[1];
              if(identifier) {
                let splitCheck = identifier.split('/');
                identifier = splitCheck[splitCheck.length-1];
                this.links[i] = {
                  brand: identifier,
                  link: link
                };
                i++;
              }
            }
          }
        }

        this.commentCount = 0;
        if(this.commentSubscription) this.commentSubscription.unsubscribe();
        this.commentSubscription = this._qb.getCommentsForQuibbl(this.quibblIdentifier).subscribe(comments => {
          if(comments) {
            this.commentCount = comments.length;
          }
        });
      });

      // Scroll to top
      try {
        this.scrollContainer.nativeElement.scrollTop = 0;
        window.scrollTo(0,0);
      } catch(err) {
        //console.log(err)
      }

      this.auth.isLoggedIn.subscribe((value: boolean) => {
        if(value) {
          if(this.currentVoteSubscription) this.currentVoteSubscription.unsubscribe();
          this.currentVoteSubscription = this._qb.getCurrentVoteForUser(params['quibblId'], this.auth.userIdentifier).subscribe(vote => {
            this.myCurrentVote = vote.vote;
          });
        }
      });

      this._qb.getNextQuibbl(this.quibblIdentifier).subscribe(nextQuibbl => {
        this.nextQuibbl = (nextQuibbl && nextQuibbl.length==2) ? nextQuibbl[0] : null;
      });

    });
  }

  ngOnDestroy() {
    if(this.identifierSubscription) this.identifierSubscription.unsubscribe();
    if(this.currentVoteSubscription) this.currentVoteSubscription.unsubscribe();
    if(this.currentQuibblSubscription) this.currentQuibblSubscription.unsubscribe();
  }

  public selectIndex(index: number) {
    let identifier = this.quibblIdentifier;
    let user = this.auth.userIdentifier;
    this._qb.voteOnQuibbl(identifier, index);
  }

  copyEmbedCode() {
    this.embedCode.nativeElement.select();
    document.execCommand( "copy" );
  }

  onScroll(event) {
    if(event.target.scrollTop < BANNER_FADE_START) {
      this.bannerAlpha = 1.0;
      this.bannerYOffset = 0.0;
    }

    else if(event.target.scrollTop > (BANNER_FADE_DISTANCE + BANNER_FADE_START)) {
      this.bannerAlpha = 0;
      this.bannerYOffset = 20;
    }

    else {
      this.bannerAlpha = 1 - ((event.target.scrollTop - BANNER_FADE_START) / BANNER_FADE_DISTANCE);
      this.bannerYOffset = 20 * ((event.target.scrollTop - BANNER_FADE_START) / BANNER_FADE_DISTANCE);
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-inspector/quibbl-inspector.component.ts